import { checkSession } from '../../Common/Utils/SsoSession';

export const SessionCheck = (view) => {
    checkSession()
        .then((session) => {
            if (session && session.State === 'LOGIN') {
                view.setState(prevState => ({ ...prevState, Session: session }));
            } else {
                view.setState(prevState => ({ ...prevState, Session: {} }));
            }
        })
        .catch(() => view.setState(prevState => ({ ...prevState, Session: {} })));
}
const safeJson = (res) => {
    if (!res.ok) return [];
    return res.text().then(text => {
        if (!text || text.trim() === '') return [];
        try { return JSON.parse(text); } catch(e) { return []; }
    });
};

export const getNewsBoardData = (view) => {
    fetch('/request/SelectNews')
        .then(safeJson)
        .then(msg => view.setState(prevState => ({ ...prevState, 공지사항_게시글: Array.isArray(msg) ? msg : [] })))
        .catch(err => console.error('SelectNews 오류:', err));
}
export const getQAboardData = (view) => {
    fetch('/request/SelectQA')
        .then(safeJson)
        .then(msg => view.setState(prevState => ({ ...prevState, QA_게시글: Array.isArray(msg) ? msg : [] })))
        .catch(err => console.error('SelectQA 오류:', err));
}

export const getFreeboardData = (view) => {
    fetch('/request/SelectFree')
        .then(safeJson)
        .then(msg => view.setState(prevState => ({ ...prevState, 자유게시판_게시글: Array.isArray(msg) ? msg : [] })))
        .catch(err => console.error('SelectFree 오류:', err));
}